import React, { useContext } from "react";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// import { Router } from "@reach/router";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import UserProvider from "../providers/UserProvider";
import ProfilePage from "../pages/ProfilePage";
import PurchasePage from "../pages/PurchasePage";
import MainPage from "../pages/MainPage";
import NotFound from "../pages/NotFound";
import { UserContext } from "../providers/UserProvider";
import PasswordReset from "./PasswordReset";
import TermsPage from "../pages/TermsPage";
import AfterSignupPage from "../pages/AfterSignupPage";
import ProfileFillingPage from "../pages/ProfileFillingPage";
import SearchLead from "../pages/SearchLead";
import PostLead from "../pages/PostLead";
import SavedLeads from "../pages/SavedLeads";
import MyLeads from "../pages/MyLeads";
import UserInbox from "../pages/UserInbox";


function Application() {
  const user = useContext(UserContext);
  
  return (
    //  user ?
    //   <Router>
    //     <ProfilePage path="Profile"/>
    //     <PurchasePage path="Purchase"/>
    //     <PurchasePage path="/" />
    //   </Router>
    //   :
    //     <Router>
    //       <SignUp path="SignUp" />
    //       <PasswordReset path = "PasswordReset" />
    //       <MainPage path = "MainPage" />
    //       <SignIn path="/" />
    //     </Router>
      user ?
      <Router>
        <Switch>
          <Route path="/Profile/:userId" render={(props) => <ProfilePage {...props} /> }>
          </Route>
          <Route path='/Profile'>
            <ProfilePage/>
          </Route>
          <Route path='/Purchase'>
            <PurchasePage/>
          </Route>
          <Route path='/terms'>
            <TermsPage/>
          </Route>
          <Route path="/Thankyou">
            <AfterSignupPage/>
          </Route>
          <Route path="/ProfileUpdate">
            <ProfileFillingPage/>
          </Route>
          <Route path="/SignUp">
            <AfterSignupPage/>
          </Route>
          <Route path='/SearchLead'>
            <SearchLead/>
          </Route>
          <Route path='/SavedLeads'>
            <SavedLeads/>
          </Route>
          <Route path='/PostLead'>
            <PostLead/>
          </Route>
          <Route path='/MyLeads'>
            <MyLeads/>
          </Route>
          <Route path='/UserInbox'>
            <UserInbox/>
          </Route>
          <Route path='/'>
            <SearchLead/>
          </Route>
          {/* <Route component={NotFound} /> */}
        </Switch>
      </Router>
      :
      <Router>
        <Switch>
          <Route path='/SignIn'>
            <SignIn/>
          </Route>
          <Route path='/PasswordReset'>
            <PasswordReset/>
          </Route>  
          <Route path="/SignUp">
            <SignUp/>
          </Route>
          <Route path="/MainPage">
            <MainPage/>
          </Route>
           <Route path='/terms' exact>
            <TermsPage/>
          </Route>
          {/* <Route component={NotFound} /> */}
        </Switch>
      </Router>
        
  );
}

export default Application;
